/**
 * Same-origin nudge for the /auth/acl session monitor.
 *
 * localStorage fired a `storage` event on every write, which is how a sign-out in one tab used
 * to reach the editor's embedded monitor instantly. Cookies fire nothing, so the signal has to
 * be sent by hand: every sign-in and sign-out posts here, and the monitor re-polls the server
 * the moment it hears it (server/views/auth-acl.ejs). Without this the monitor's 10s interval
 * would be the only signal, and "I signed out on the web but the editor still thinks I'm in"
 * would last up to that long.
 *
 * Best-effort by design: BroadcastChannel is unavailable in a few embedded webviews and is
 * partitioned in cross-site frames. The interval poll remains the floor in both cases.
 */

/** Must match AUTH_CHANNEL_NAME in server/ssr/auth-acl.ts. */
const AUTH_CHANNEL_NAME = "muhaha:auth";

export function notifyAuthChanged(): void {
	try {
		const channel = new BroadcastChannel(AUTH_CHANNEL_NAME);
		channel.postMessage("changed");
		channel.close();
	} catch {
		// No BroadcastChannel here; the monitor's poll still converges.
	}
}
